import React, { useState, useEffect } from "react";
import "./DungeonStyles.css";

const DamageText = (props) => {
  const [text, setText] = useState([]);

  const randomRotation = (min, max) => {
    return Math.random() * (max - min) + min;
  };

  useEffect(() => {
    const handleTextAnim = (e) => {
      const { damage } = e.detail;
      const newText = {
        id: Date.now() + damage, // Уникальный идентификатор
        damage: damage, // Сохраняем текущее значение урона
        // rotation: randomRotation(-10, 10),
      };
      setText((prevText) => [...prevText, newText]);

      setTimeout(() => {
        setText((prevText) =>
          prevText.filter((text) => text.id !== newText.id)
        );
      }, 3000);
    };

    document.addEventListener(props.eventName, handleTextAnim);

    return () => {
      document.removeEventListener(props.eventName, handleTextAnim);
    };
  }, [props.trigger]); // Зависимость от props.text

  return (
    <>
      {text.map((text) => (
        <div
          key={text.id}
          // style={{ rotate: text.rotation + "deg" }}
          className="damage-text"
        >
          {text.damage} {/* Используем сохраненное значение урона */}
        </div>
      ))}
    </>
  );
};

export default DamageText;
